import useToggle from '../../Toggle/useToggle';
import NewToggleMobile from '../NewToggleMobile';

type Props = {
  showTooltip: (messageId: string) => void;
};

const MobileToggle: FC<Props> = ({ showTooltip }) => {
  const { total, isLiked, handleClick } = useToggle({ showTooltip });

  return (
    <NewToggleMobile total={total} isLiked={isLiked} onClick={handleClick} />
  );
};

export default MobileToggle;
